module.exports = __webpack_public_path__ + "img/Sagitta.8895df88.png";